import React from 'react';

export default function SeeMoreModal({ handleClose, open, recipe }) {
  return (
    <div className="modal-container">
      <div className="modal" id="modal">
        <div className="modal-header">
          <div className="title">{recipe.title}</div>
          <button onClick={handleClose} className="close-button">
            &times;
          </button>
        </div>
        <div className="modal-horizontal">
          <div>
            <div className="image">
              <img src={recipe.image} alt="recipe" />
            </div>
          </div>
          <div>
            <div className="modal-body">
              <div className="image"></div>
              <div className="credits">
                <span>Recipe uploaded by: </span>
                <p>{recipe.creditsText}</p>
              </div>
              <br />
              <div className="readiyIn">
                <span>Ready in: </span>
                {recipe.readyInMinutes} minutes
              </div>
            </div>
            <div className="categories">
              <div>
                <p>
                  Vegetarian:{' '}
                  {recipe.vegetarian ? (
                    <span role="img" aria-label="compatible">
                      ✔️
                    </span>
                  ) : (
                    <span role="img" aria-label="not compatible">
                      ❌
                    </span>
                  )}
                </p>
                <p>
                  Vegan:{' '}
                  {recipe.vegan ? (
                    <span role="img" aria-label="compatible">
                      ✔️
                    </span>
                  ) : (
                    <span role="img" aria-label="not compatible">
                      ❌
                    </span>
                  )}
                </p>
                <p>
                  Gluten Free:{' '}
                  {recipe.glutenFree ? (
                    <span role="img" aria-label="compatible">
                      ✔️
                    </span>
                  ) : (
                    <span role="img" aria-label="not compatible">
                      ❌
                    </span>
                  )}
                </p>
              </div>
              <div>
                <p>
                  Dairy Free:{' '}
                  {recipe.dairyFree ? (
                    <span role="img" aria-label="compatible">
                      ✔️
                    </span>
                  ) : (
                    <span role="img" aria-label="not compatible">
                      ❌
                    </span>
                  )}
                </p>
                <p>
                  Healthy:{' '}
                  {recipe.veryHealthy ? (
                    <span role="img" aria-label="compatible">
                      ✔️
                    </span>
                  ) : (
                    <span role="img" aria-label="not compatible">
                      ❌
                    </span>
                  )}
                </p>
                <p>
                  Health Score:{' '}
                  <span className="num">{recipe.healthScore}%</span>
                </p>
              </div>
            </div>
            <div className="link">
              <a href={recipe.spoonacularSourceUrl}>
                Cook it..
                <span role="img" aria-label="link">
                  🔗
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
